mutation Inertia_UpdateMember($memberId: ID!, $role: MemberRoleEnum!, $name: String!, $email: String!, $officer: Boolean) {
  updateMember(input: { memberId: $memberId, role: $role, name: $name, email: $email, officer: $officer }) {
    member {
      id
      role
      name
      email
      officer
    }
    errors
  }
}